import { ScaleOptions } from "@/shared/part-recognition/dialog/part-recognition-dialog.vue";

export const resizeElementToBlob = async (
    element: HTMLVideoElement | HTMLImageElement | ImageBitmap,
    width: number,
    height: number
): Promise<Blob | null> => {
    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext("2d");
    if (!ctx) {
        console.error("Canvas context not available");
        return null;
    }

    ctx.drawImage(element, 0, 0, width, height);

    return new Promise((resolve) => {
        canvas.toBlob((blob) => {
            if (!blob) {
                console.error("Failed to convert canvas to blob");
                resolve(null);
            } else {
                resolve(blob);
            }
        }, "image/jpeg");
    });
};

export const scaleImageToBlob = async (image: File | Blob, options: ScaleOptions = {}) => {
    const bitmap = await createImageBitmap(image);

    //Dimensions of original image
    const { width, height } = bitmap;
    const { maxResolution, maxDimensions } = options;
    const totalPixels = width * height;

    let scale = 1;

    if (maxResolution && totalPixels > maxResolution) {
        scale = Math.sqrt(maxResolution / totalPixels);
    } else if (maxDimensions) {
        const { maxSideLength, shortSideLength } = maxDimensions;

        const isLandscape = width >= height;
        const longLength = isLandscape ? width : height;
        const shortLength = isLandscape ? height : width;

        if (longLength > maxSideLength || shortLength > shortSideLength) {
            const longScale = maxSideLength / longLength;
            const shortScale = shortSideLength / shortLength;
            scale = Math.min(longScale, shortScale);
        }
    }

    if (scale >= 1) {
        return image;
    }

    const targetWidth = Math.floor(width * scale);
    const targetHeight = Math.floor(height * scale);

    //Create blob with new target dimensions
    return await resizeElementToBlob(bitmap, targetWidth, targetHeight);
};
